<template>
  <div class="gmf-text-input">
    <input ref="input" type="text" :placeholder="placeholder" :maxlength="maxlength" :value="modelValue || ''" @input="onUpdate"
      :style="computedStyle" @keydown.enter="e => $emit('keydown.enter', e)" @blur="e => $emit('blur', e)" :aria-label="ariaLabel" />
  </div>
</template>

<style>
.gmf-text-input {
  width: 100%;
}
.gmf-text-input input {
  background: var(--gmf-input-bg);
  border: none;
  padding: 12px 16px;
  border-radius: var(--gmf-rounding);
  width: 100%;
  font-size: var(--gmf-default-font-size);
}
.gmf-text-input input::placeholder {
  color: var(--gmf-col-darkgray);
}
</style>

<script>
import getBrowserInfo from '@/utils/tracking';

const info = getBrowserInfo();

const isIOS = info.device.os === 'iOS';

export default {
  props: ['modelValue', 'placeholder', 'maxlength', 'autofocus', 'ariaLabel'],

  computed: {
    computedStyle() {
      if (isIOS) {
        return {
          fontSize: '16px',
        }
      }

      return null;
    },
  },

  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus();
    }
  },

  methods: {
    onUpdate (evt) {
      this.$emit('update:modelValue', evt.target.value);
    },
  },
};
</script>
